<div>
    <div [hidden]="!loader" class="loading-data">
        <img style="height: 10vh" src="./assets/loader/loader.gif" />
    </div>
</div>